import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SsoService } from '../core/services/sso.service';
import { first } from 'rxjs/operators';
import { AuthenticationService } from '../core/services/authentication.service';
import { BearerService } from '../core/services/bearer-service.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.css']
})
export class SsoComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private ssoService: SsoService,
    private authService: AuthenticationService,
    private bearerService: BearerService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      const paramLength = Object.keys(params).length;
      const clientId: string = params['clientId'];
      if (clientId && paramLength == 1) {
        this.callAuthSsoClient(clientId);
        return;
      }
      const client = params['client'];
      const token = params['token'];
      if (client && token && paramLength == 2) {
        this.manageUserAuthenticate(client, token);
        return;
      }
      this.redirectErrorPageSsoError('Página no encontrada');
    });
  }
  private manageUserAuthenticate(clientId: string, token: string) {
    this.bearerService.setBearer(clientId + 'Bearer ');
    localStorage.setItem('currentUser', JSON.stringify({
      token: token
    }));
    this.authService.redirectToLoadUserData(false, token);
  }
  private redirectErrorPageSsoError(message: string) {
    this.router.navigate(['error'], { queryParams: { message: message } });
  }
  private callAuthSsoClient(clientId: string) {
    this.ssoService.getUrlAuthSsoClient(clientId)
      .pipe(first()).subscribe((url) => {
        this.bearerService.setBearer(clientId + 'Bearer ');
        window.location.href = url;
      }, error => {
          this.bearerService.setBearer('DocoutBearer ');
          this.redirectErrorPageSsoError(`No se ha podido recoger la información del sso para el cliente ${clientId}`);
       } );
  }

}
